import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { getCategoryDisplayName } from '../utils/categoryUtils';
import './LatestPosts.css';

const LatestPosts = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Static posts data as fallback
  const staticPosts = [
    {
      _id: '1',
      title: 'Naš put do dve crtice: iskreno iskustvo sa problemima sa začećem',
      excerpt: 'Iskrena priča o izazovima sa začećem, emocionalnim usponima i padovima, i konačno o radosti kada se pojave dve crtice na testu.',
      categoryId: 'zacece',
      featuredImage: 'nas-put-do-dve-crtice.png',
      createdAt: new Date().toISOString(),
      content: 'Iskrena priča o izazovima sa začećem...'
    },
    {
      _id: '2',
      title: 'Prvi trimestar moje trudnoće',
      excerpt: 'Lično iskustvo prvog trimestra - od prvih simptoma do prvih pregleda. Sve što sam osećala i naučila u prva tri meseca.',
      categoryId: 'trudnoca',
      featuredImage: 'prvi-trimestar-moje-trudnoce.png',
      createdAt: new Date().toISOString(),
      content: 'Lično iskustvo prvog trimestra...'
    },
    {
      _id: '3',
      title: 'Moja priprema za porođaj',
      excerpt: 'Kako sam se pripremala za najvažniji dan - od kurseva za trudnice do pakovanja torbe za porodilište.',
      categoryId: 'porodjaj',
      featuredImage: 'moja-priprema-za-porodjaj.png',
      createdAt: new Date().toISOString(),
      content: 'Kako sam se pripremala za najvažniji dan...'
    },
    {
      _id: '4',
      title: 'Prvo putovanje',
      excerpt: 'Naše prvo putovanje sa bebom - saveti, priprema i iskustva koja će vam pomoći da se osećate sigurno na putu.',
      categoryId: 'zivot-sa-bebom',
      featuredImage: 'prvo-putovanje.jpg',
      createdAt: new Date().toISOString(),
      content: 'Naše prvo putovanje sa bebom...'
    }
  ];

  useEffect(() => {
    fetchLatestPosts();
  }, []);

  const fetchLatestPosts = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'https://jakakaomajka.com/backend';
      const response = await axios.get(`${apiUrl}/api/posts`);
      // Ensure response.data is an array and take only the first 4 posts
      const postsData = Array.isArray(response.data) ? response.data : [];
      setPosts(postsData.slice(0, 4));
    } catch (err) {
      // If backend is not available, use static posts
      console.log('Backend not available, using static posts');
      setPosts(staticPosts);
      setError(null);
    } finally {
      setLoading(false);
    }
  };

  // Function to calculate reading time
  const calculateReadingTime = (content) => {
    const wordsPerMinute = 200;
    const words = content ? content.split(' ').length : 0;
    const minutes = Math.ceil(words / wordsPerMinute);
    return `${minutes} min čitanja`;
  };

  // Function to format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('sr-RS', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  const getFeaturedImageUrl = (imagePath) => {
    if (imagePath.startsWith('http')) {
      return imagePath;
    }
    const possiblePaths = [
      `https://jakakaomajka.com/uploads/${imagePath}`,
      `https://jakakaomajka.com/backend/uploads/${imagePath}`,
      `https://jakakaomajka.com/${imagePath}`,
      `https://jakakaomajka.com/backend/${imagePath}`
    ];
    console.log('Trying image paths for LatestPosts:', possiblePaths);
    return possiblePaths[0]; // Start with the first path
  };

  if (loading) {
    return (
      <div className="latest-posts-section">
        <div className="container mx-auto px-4 py-12">
          <h2 className="latest-posts-title">Najnoviji članci</h2>
          <div className="loading-message">Učitavam najnovije članke...</div>
        </div>
      </div>
    );
  }

  if (error && posts.length === 0) {
    return (
      <div className="latest-posts-section">
        <div className="container mx-auto px-4 py-12">
          <h2 className="latest-posts-title">Najnoviji članci</h2>
          <div className="error-message">Greška pri učitavanju članaka: {error}</div>
        </div>
      </div>
    );
  }

  if (posts.length === 0) {
    return (
      <div className="latest-posts-section">
        <div className="container mx-auto px-4 py-12">
          <h2 className="latest-posts-title">Najnoviji članci</h2>
          <div className="no-posts-message">Trenutno nema objavljenih članaka.</div>
        </div>
      </div>
    );
  }

  return (
    <div className="latest-posts-section">
      <div className="container mx-auto px-4 py-12">
        <h2 className="latest-posts-title">Najnoviji članci</h2>
        <div className="latest-posts-grid">
          {Array.isArray(posts) && posts.map((post, index) => (
            <Link to={`/post/${post._id}`} key={post._id} className="latest-post-card">
              <div className="post-image-container">
                {post.featuredImage ? (
                  <img
                    src={getFeaturedImageUrl(post.featuredImage)}
                    alt={post.title}
                    className="post-image"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                ) : (
                  <div className="post-image-placeholder" style={{ display: 'flex' }}>
                    <span>Nema slike</span>
                  </div>
                )}
                <div className="post-image-placeholder" style={{ display: 'none' }}>
                  <span>Slika se učitava...</span>
                </div>
              </div>
              
              <div className="post-content">
                {post.categoryId && (
                  <div className="post-tag">
                    {getCategoryDisplayName(post.categoryId)}
                  </div>
                )}
                
                <h3 className="post-title">{post.title}</h3>
                
                <p className="post-excerpt">
                  {post.excerpt || 'Pročitajte više...'}
                </p>
                
                <div className="post-meta">
                  <div className="post-date">
                    <svg className="calendar-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 2V6M16 2V6M3 10H21M5 4H19C20.1046 4 21 4.89543 21 6V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V6C3 4.89543 3.89543 4 5 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    {formatDate(post.createdAt)}
                  </div>
                  
                  <div className="reading-time">
                    <svg className="clock-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                      <polyline points="12,6 12,12 16,14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    {calculateReadingTime(post.content)}
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LatestPosts; 